<template>
  <a href="/">
    <div class="logo-img"></div>
  </a>
</template>

<script>
export default {
  name: 'LogoImg',
  props: {
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
